import { Button, Col, Modal, Row, Tag } from "antd";
import React from "react";
import { useSelector } from "react-redux";

function ApproveUnitModal(props) {
  const positionState = useSelector((state) => state.positionState.value);

  return (
    <Modal
      title={"Approve unit"}
      visible={props.visible}
      onOk={props.handleOk}
      onCancel={props.handleCancel}
      footer={null}
    >
      <Row>
        <Col span={12} className="mb-6">
          <div className="text-xs">Unit name</div>
          <div>{props.data?.data?.name}</div>
        </Col>
        <Col span={12} className="mb-6">
          <div className="text-xs">Unit type</div>
          <div>{props.data?.data?.organizationLevel?.name}</div>
        </Col>
        <Col span={12} className="mb-6">
          <div className="text-xs">Head unit</div>
          <div>{props.data?.data?.headUnit?.name}</div>
        </Col>
        <Col span={12} className="mb-6">
          <div className="text-xs">Added on</div>
          <div>{props.data?.data?.createdOn?.slice(0, 10)}</div>
        </Col>
      </Row>
      {positionState?.userRole?.name !== "Manager"
        ? props.data?.status === "Pending" && (
            <div className="mt-6 flex justify-end">
              <Button danger className="mr-3" onClick={props.handleReject}>
                Reject
              </Button>
              <Button type="primary" htmlType="submit" onClick={props.handleOk}>
                Approve
              </Button>
            </div>
          )
        : props.data?.status === "Pending" && (
            <div className="mt-6 flex justify-end">
              <Button danger className="mr-3" onClick={props.handleDelete}>
                Delete
              </Button>
            </div>
          )}
    </Modal>
  );
}

export default ApproveUnitModal;
